import type { SiteId, SiteSettings } from '../types/site-settings';

/**
 * Code-level defaults for each site.
 * These are used as fallbacks when the DB value hasn't been set yet,
 * or if the metadata API is unreachable.
 */

const sizzlenzDefaults: SiteSettings = {
  siteName: 'Sizzle NZ',
  tagline: 'New Zealand’s FMCG growth platform',
  domain: 'sizzle.nz',

  contactEmail: 'hello@sizzle.nz',
  supportEmail: 'support@sizzle.nz',
  socialLinks: {
    linkedin: 'https://linkedin.com/company/sizzlenz',
  },

  logoUrl: '/logo-sizzlenz.svg',
  faviconUrl: '/favicon.ico',
  ogImageUrl: '/og-sizzlenz.png',

  seoTitleSuffix: '| Sizzle NZ',
  seoDefaultDescription:
    'Get products known, tried and purchased. Connect with brands, retailers, buyers, distributors and partners across the New Zealand FMCG ecosystem.',

  sectorTerm: 'FMCG',

  country: 'New Zealand',
  countryCode: 'NZ',
  currency: 'NZD',
  locale: 'en-NZ',
  defaultRegion: 'NZ-AUK',

  features: {
    quizzes: true,
    consumerMode: true,
    affiliateLinks: false,
    dataImport: true,
    mapView: true,
    tradeHub: true,
  },

  officeHoursHub: {
    id: 20,
    slug: 'office-hours',
  },
};

const sizzlecpgDefaults: SiteSettings = {
  siteName: 'Sizzle CPG',
  tagline: 'The CPG growth platform',
  domain: 'sizzlecpg.com',

  contactEmail: 'hi@sizzlecpg.com',
  supportEmail: 'support@sizzlecpg.com',
  socialLinks: {
    linkedin: 'https://linkedin.com/company/sizzlecpg',
  },

  logoUrl: '/logo-sizzlecpg.svg',
  faviconUrl: '/favicon.ico',
  ogImageUrl: '/og-sizzlecpg.png',

  seoTitleSuffix: '| Sizzle CPG',
  seoDefaultDescription:
    'Get products known, tried and purchased. Connect with brands, retailers, buyers, distributors and partners across the CPG ecosystem.',

  sectorTerm: 'CPG',

  country: 'United States',
  countryCode: 'US',
  currency: 'USD',
  locale: 'en-US',
  defaultRegion: 'US',

  features: {
    quizzes: true,
    consumerMode: false,
    affiliateLinks: true,
    dataImport: true,
    mapView: true,
    tradeHub: true,
  },
};

const yummmsyDefaults: SiteSettings = {
  siteName: 'yummmsy',
  tagline: 'Snack discovery, games and prizes',
  domain: 'yummmsy.com',

  contactEmail: 'hello@yummmsy.com',
  supportEmail: 'support@yummmsy.com',
  socialLinks: {
    instagram: 'https://instagram.com/yummmsy',
  },

  logoUrl: '/logo-yummmsy.svg',
  faviconUrl: '/favicon.svg',
  ogImageUrl: '/og-yummmsy.png',

  seoTitleSuffix: '| yummmsy',
  seoDefaultDescription:
    'Hunt down the tastiest new food and drink, rate it with people who actually care, and play your way to free stuff.',

  sectorTerm: 'snacks',

  country: 'United States',
  countryCode: 'US',
  currency: 'USD',
  locale: 'en-US',
  defaultRegion: 'US',

  features: {
    quizzes: true,
    consumerMode: true,
    affiliateLinks: true,
    dataImport: true,
    mapView: false,
    tradeHub: false,
  },
};

export const SITE_SETTINGS_DEFAULTS: Record<SiteId, SiteSettings> = {
  sizzlenz: sizzlenzDefaults,
  sizzlecpg: sizzlecpgDefaults,
  yummmsy: yummmsyDefaults,
};

/** The metadata key used to store site settings in the DB */
export const SITE_SETTINGS_METADATA_KEY = 'site-settings';
